import React from "react";
import Page, { PageProps } from "../Page";
import { IFormTypesPresenter } from "../../../presenter/formconfiguration/FormTypesPresenter";
import DataGrid from "../../components/app/grid/DataGrid";
import CreateFormTypeForm, {
  CreateFormTypeFormProps
} from "./CreateFormTypeForm";
import UpdateFormTypeForm, {
  UpdateFormTypeFormProps
} from "./UpdateFormTypeForm";
import { Form } from "antd";
import FormTypeCopyDialog from "./FormTypeCopyDialog";
import { TGridAction } from "../../components/app/grid/GridActionsDropdown";
import FormTypesExpanded from "./FormTypesExpanded";
import Loader from "../../components/Loader";
import NewFormVersionDialog from "./NewFormVersionDialog";
import PublishFormVersionDialog from "./PublishFormVersionDialog";
import CancelFormVersionDialog from "./CancelFormVersionDialog";
import { FormTypeConstants } from "../../../common/Constants";
import { IFormType } from "../../../model/formconfiguration/FormType";

export interface Props extends PageProps {}
export interface State extends IFormTypesPresenter {}

export default class FormTypesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      formTypes,
      copyFormModalVisible,
      showCopyFormModal,
      hideCopyFormModal,
      copyFormType,
      setRowData,
      rowData,
      newFromVersionModalVisible,
      showNewFormVersionModal,
      hideNewFormVersionModal,
      createNewFormVersion,
      publishFormVersionDialogVisible,
      hidePublishFormVesionDialog,
      showPublishFormVesionDialog,
      publishFormVersion,
      cancelFormVersionDialogVisible,
      hideCancelFormVersionDialog,
      showCancelFormVersionDialog,
      cancelFormVersion
    } = this.state;

    const CreateForm = Form.create<CreateFormTypeFormProps>({})(
      CreateFormTypeForm
    );

    const UpdateForm = Form.create<UpdateFormTypeFormProps>({})(
      UpdateFormTypeForm
    );

    const actions: TGridAction[] = [
      {
        label: translate("formTypes_page.configure_form"),
        type: "primary",
        onClick: (record) => (e) => {
          this.state.redirect(`form-types/${record.code}/configuration`);
        }
      },
      {
        label: translate("formTypes_page.copy_form"),
        type: "default",
        onClick: (record) => (e) => {
          setRowData(record);
          showCopyFormModal();
        }
      },
      {
        label: translate("formTypes_page.create_new_version"),
        type: "default",
        onClick: (record) => (e) => {
          setRowData(record);
          showNewFormVersionModal();
        },
        enable: (record: IFormType) => {
          return (
            record.status === FormTypeConstants.STATUS.PUBLISHED ||
            record.status === FormTypeConstants.STATUS.CANCELLED
          );
        }
      },
      {
        label: translate("formTypes_page.publish_version"),
        type: "default",
        onClick: (record) => (e) => {
          setRowData(record);
          showPublishFormVesionDialog();
        },
        enable: (record: IFormType) => {
          return record.status === FormTypeConstants.STATUS.PREPARATION;
        }
      },
      {
        label: translate("formTypes_page.cancel_version"),
        type: "danger",
        onClick: (record) => (e) => {
          setRowData(record);
          showCancelFormVersionDialog();
        },
        enable: (record: IFormType) => {
          return (
            record.status === FormTypeConstants.STATUS.PUBLISHED ||
            record.status === FormTypeConstants.STATUS.PREPARATION
          );
        }
      }
    ];

    const columns = [
      {
        title: translate("formTypes_page.code"),
        dataIndex: "code",
        key: "code"
      },
      {
        title: translate("formTypes_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("formTypes_page.status"),
        dataIndex: "status",
        key: "status"
      },
      {
        title: translate("formTypes_page.previous_version"),
        dataIndex: "previousFormVersionCode",
        key: "previousFormVersionCode"
      }
    ];
    const expandedRowRender = (e) => {
      return (
        <FormTypesExpanded
          translate={translate}
          evaluationTypeLoader={this.state.loaders.evaluationTypeLoader}
          assignedEvaluationTypeIds={this.state.assignedEvaluationTypeIds}
          evaluationTypes={this.state.evaluationTypes}
          onEvaluationTypeSelectChange={this.state.onEvaluationTypeSelectChange}
        />
      );
    };

    const dataGrid = (
      <DataGrid
        actions={actions}
        title={translate("grids.form-types")}
        translate={translate}
        columns={columns}
        dataSource={formTypes}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        createModalTitle={translate("formType_form.insert_modal_title")}
        onCreate={this.state.createFormType}
        updateForm={UpdateForm}
        updateModalTitle={translate("formType_form.update_modal_title")}
        onUpdate={this.state.updateFormType}
        booleanColumnKeys={["valid"]}
        expandedRowRender={expandedRowRender}
        singleRowExpandEnabled={true}
        onExpand={this.state.onRowExpanded}
        addButtonText={translate("formType_form.add_button_text")}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.formTypesLoader}
        />
        <FormTypeCopyDialog
          copyFormModalVisible={copyFormModalVisible}
          hideCopyFormModal={hideCopyFormModal}
          translate={translate}
          rowData={rowData}
          copyFormType={copyFormType}
        />
        <NewFormVersionDialog
          translate={translate}
          hideNewFormVersionModal={hideNewFormVersionModal}
          createNewFormVersion={createNewFormVersion}
          newFormVersionModalVisible={newFromVersionModalVisible || false}
          rowData={rowData}
        />
        <PublishFormVersionDialog
          publishFormVersionDialogVisible={
            publishFormVersionDialogVisible || false
          }
          hidePublishFormVersionDialog={hidePublishFormVesionDialog}
          translate={translate}
          publishFormVersion={publishFormVersion}
          rowData={rowData}
        />
        <CancelFormVersionDialog
          cancelFormVersionDialogVisible={
            cancelFormVersionDialogVisible || false
          }
          hideCancelFormVersionDialog={hideCancelFormVersionDialog}
          translate={translate}
          cancelFormVersion={cancelFormVersion}
          rowData={rowData}
        />
      </Page>
    );
  }
}
